import { news_sendBroadcastNotification } from '../components/news_sendBroadcastNotification'



export async function preInsert(entity, data) {
    
    var d = {...data}

    if(entity === 'sample') {
        d.sample1 = 'test'
    }

    if(entity === 'news'){
        return await news_sendBroadcastNotification(d, 'insert')
    }
    
    return {
        success: 1,
        data: d,
        message: ''
    }
}